import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-transaction-in-process',
  templateUrl: './transaction-in-process.component.html',
  styleUrls: ['./transaction-in-process.component.scss'],
})
export class TransactionInProcessComponent implements OnInit {

  @Input() text: string;
  @Input() status: string;

  constructor(public modalController : ModalController) { }

  ngOnInit() {}

  closeModal(){
    this.modalController.dismiss();
  }

  redirectDashboard(){
    this.modalController.dismiss({'action': 'redirectToDashboard'});
  }

}
